import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import farmerImage1 from "./../../assets/Farmer.png";
import farmerImage2 from "./../../assets/img/slider.avif";
import farmerImage3 from "./../../assets/img/slider2.webp";
import farmerImage4 from "./../../assets/img/slider3.jpg";
import farmerImage5 from "./../../assets/img/slider4.avif";
import farmerImage6 from "./../../assets/img/slider5.avif";

import img1 from "./../../assets/img/Settings7527/hsdcl_certificate.jpg";
import img2 from "./../../assets/img/Settings7527/scan0003_0.jpg";
import img3 from "./../../assets/img/Settings7527/scan0004.jpg";
import img4 from "./../../assets/img/Settings7527/scan0005.jpg";
import img5 from "./../../assets/img/Settings7527/scan0006.jpg";
import img6 from "./../../assets/img/Settings7527/scan0009.jpg";
import img7 from "./../../assets/img/Settings7527/scan0010.jpg";
import img8 from "./../../assets/img/Settings7527/scan0013.jpg";
import img9 from "./../../assets/img/Settings7527/scan0019_0.jpg";
import img10 from "./../../assets/img/Settings7527/scan0026.jpg";
import img11 from "./../../assets/img/Settings7527/scan0043.jpg";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import "./Home.css";
import axios from "axios";
import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import Loader from "../Loader/Loader";

const Home = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [notifications, setNotifications] = useState([]);
  const [links, setLinks] = useState([]);
  const [images, setImages] = useState([]);
  // const images = [
  //   farmerImage1,
  //   farmerImage2,
  //   farmerImage3,
  //   farmerImage4,
  //   farmerImage5,
  //   farmerImage6,
  // ];
  // const imagesGallery = [
  //   img1,
  //   img2,
  //   img3,
  //   img4,
  //   img5,
  //   img6,
  //   img7,
  //   img8,
  //   img9,
  //   img10,
  //   img11,
  // ];
  const [imagesGallery, setImagesGallery] = useState([]);
  const scrollGallery = (direction) => {
    const container = document.getElementById("galleryContainer");
    const scrollAmount = 200; 
    const duration = 300;
    const interval = 10; 
    const steps = duration / interval; 
  
    let stepCount = 0;
    const stepSize = scrollAmount / steps; 
  
    const scrollStep = () => {
      if (stepCount < steps) {
        container.scrollLeft += direction === "left" ? -stepSize : stepSize;
        stepCount++;
        setTimeout(scrollStep, interval); 
      }
    };
  
    scrollStep(); 
  };

  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark-mode-body"));
    };

    checkDarkMode();

    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect(); 
  }, []);


    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await axios.post(
            `${BaseUrl}/api/v1/files/getImages`,
            { location: "Photo Gallery" },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          if (res.data.status === 200 && Array.isArray(res.data.data)) {
            const processedImages = res.data.data.map((img, index) => ({
              src: img.file ? `data:image/png;base64,${img.file}` : "",
              key: index + 1,
            }));
            setImagesGallery(processedImages);
          } else {
            toast.error(res.data.message || "Failed to load images.");
          }

          const resHome = await axios.post(
            `${BaseUrl}/api/v1/files/getImages`,
            { location: "Home Corousel" },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          if (resHome.data.status === 200 && Array.isArray(resHome.data.data)) {
            const processedImages = resHome.data.data.map((img, index) => ({
              src: img.file ? `data:image/png;base64,${img.file}` : "",
              key: index + 1,
            }));
            setImages(processedImages);
          } else {
            toast.error(resHome.data.message || "Failed to load images.");
          }
          const resNote = await axios.post(
            `${BaseUrl}/api/notifications/getNotification`,
            { location: "All" },
            {
              headers: { "Content-Type": "application/json" },
            }
          );
  
          if (resNote.data.status === 200) {
            setNotifications(
              resNote.data.data.map((img) => ({
                id: img.key,
                title: img.title,
                file: `data:application/pdf;base64,${img.file}` || "",
                location: img.location,
              }))
            );
          } else {
            toast.error("Failed to fetch Notifications.");
          }
  
          // const resLink = await axios.post(
          //   `${BaseUrl}/api/links/getAll`,
          //   { location: "All" },
          //   {
          //     headers: {
          //       "Content-Type": "application/json",
          //     },
          //   }
          // );
  
          // if (resLink.data.status === 200) {
          //   setLinks(
          //     resLink.data.data.map((img) => ({
          //       id: img.key,
          //       title: img.title,
          //       link: img.link,
          //       location: img.location,
          //     }))
          //   );
          // } else {
          //   toast.error("Failed to fetch links.");
          // }
        } catch (error) {
          toast.error(error.response?.data?.message || "An error occurred");
        }
        finally{
          setLoading(false);
        }
      };
  
      if (location.pathname) fetchData();
    }, [location.pathname]);
  return (
    <>
    {loading ? (
      <Loader />
    ) : (
    <div className="my-3">
      <div className="mb-3">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="2000" 
        >
      
          <ol className="carousel-indicators">
            {images.map((_, index) => (
              <li
                key={index}
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                style={{
                  width: "15px",
                  height: "15px",
                  borderRadius: "50%",
                  backgroundColor: "grey", 
                  margin: "0 5px",
                  cursor: "pointer", 
                }}
              ></li>
            ))}
          </ol>
          <div className="carousel-inner">
            {images.map((image, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                key={index}
              >
                <img
                  src={image.src}
                  className="d-block w-100"
                  alt={`Slide ${index + 1}`}
                  style={{
                    objectFit: "cover",
                    height: "60vh",
                  }}
                />
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
            style={{backgroundColor:"transparent"}}
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
            style={{backgroundColor:"transparent"}}
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>


      <div className="mb-3">
        <div className="card shadow-lg">
          <div className={`card-body ${isDarkMode ? "dark-mode-body" : ""}`}>
          
            <div
              style={{
                backgroundColor: "#198754",
                color: "white",
                padding: "5px", 
                fontWeight: "bold",
                borderRadius: "5px",
                width: "100%",
                marginBottom: "20px", 
                textAlign: "left",
              }}
            >
              <h4 style={{ margin: 0 }}>About Us</h4>
            </div>

         
            <div className="mt-3">
              <p style={{ textAlign: "left" }}>
                The Haryana Seeds Development Corporation Limited was
                established in the year 1974 under the Companies Act, 1956 with
                the objective of organizing production and distribution of
                certified seeds to the farmers of the State at reasonable rates.
              </p>
              <p style={{ textAlign: "left" }}>
                The Authorized Share Capital of the Corporation is Rs. 7.00
                crore. The Share Capital is contributed by the State Government,
                National Seeds Corporation Limited and Shareholder Seed Growers
                of the Corporation.
              </p>
              <p style={{ textAlign: "left" }}>
                The Corporation has the distinction to have senior Civil
                Servants as its Chairman and Managing Director. Civil Servants
                from the Indian Administrative Service have acted as
                Chairman/Managing Director and guided the Corporation since its
                inception to reach its glorious present. Their rich and vast
                experience has brought about significant improvement in the
                working and development of the Corporation.
              </p>
            </div>

            <div className="text-end mt-3">
              <Link to="/about-us" className="btn btn-success">
                See More <FaArrowRight className="ms-2" />{" "}
             
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <div className="card shadow-lg">
          <div className={`card-body ${isDarkMode ? "dark-mode-body" : ""}`}>
            <div
              style={{
                backgroundColor: "#198754",
                color: "white",
                padding: "5px",
                fontWeight: "bold",
                borderRadius: "5px",
                width: "100%",
                marginBottom: "20px",
                textAlign: "left",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h4 style={{ margin: 0 }}>Photo Gallery</h4>
              <Link
                to={"/photo-gallery"}
                className="btn btn-link text-light me-3"
                style={{ fontSize: "1rem",textDecoration:'none',padding:'0'}}
              >
                View All
              </Link>
            </div>

          
            <div
              className="d-flex overflow-hidden position-relative"
              style={{
                alignItems: "center",
              }}
            >
              
              <div
                id="galleryContainer"
                className="d-flex"
                style={{
                  overflowX: "hidden",
                  scrollBehavior: "smooth",
                  whiteSpace: "nowrap",
                  paddingBottom: "10px",
                  gap: "15px",
                  width: "100%",
                  transition: "transform 0.3s ease-in-out"
                }}
              >
                {imagesGallery.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      flex: "0 0 auto",
                      width: "200px",
                    }}
                  >
                    <img
                      src={image.src}
                      alt={`Photo ${index + 1}`}
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "150px", 
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                ))}
              </div>

            
              <button
                onClick={() => scrollGallery("left")}
                 className="scroll-button"
                 style={{ left: 0 }}
              >
                <FaArrowLeft />
              </button>
              <button
                onClick={() => scrollGallery("right")}
                 className="scroll-button"
                 style={{ right: 0 }}
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
     )}
    </>
  );
};

export default Home;
